import { alpha } from '@mui/material/styles';

const withAlphas = (color) => {
  return {
    ...color,
    alpha4: alpha(color.main, 0.04),
    alpha8: alpha(color.main, 0.08),
    alpha12: alpha(color.main, 0.12),
    alpha30: alpha(color.main, 0.3),
    alpha50: alpha(color.main, 0.5),
  };
};

export const neutral = {
  main: '#627792',
  50: '#F6F7F9',
  100: '#EDF1F5',
  200: '#E1E7EF',
  300: '#D2DAE4',
  400: '#BFCBD9',
  500: '#91A1B7',
  600: '#627792',
  700: '#485B73',
  800: '#323F50',
  900: '#0A0E13',
};

export const blue = withAlphas({
  lightest: '#F5F8FF',
  light: '#5AB9EA',
  main: '#47A2F7',
  dark: '#1E87C8',
  darkest: '#00359E',
  contrastText: '#FFFFFF',
});

export const success = withAlphas({
  lightest: '#F0FDF9',
  light: '#3FC79A',
  main: '#10B981',
  dark: '#0B815A',
  darkest: '#134E48',
  contrastText: '#FFFFFF',
});

export const info = withAlphas({
  lightest: '#ECFDFF',
  light: '#CFF9FE',
  main: '#06AED4',
  dark: '#0E7090',
  darkest: '#164C63',
  contrastText: '#FFFFFF',
});

export const warning = withAlphas({
  lightest: '#FFFAEB',
  light: '#FEF0C7',
  main: '#F79009',
  dark: '#B54708',
  darkest: '#7A2E0E',
  contrastText: '#FFFFFF',
});

export const error = withAlphas({
  lightest: '#FEF3F2',
  light: '#FEE4E2',
  main: '#F04438',
  dark: '#B42318',
  darkest: '#7A271A',
  contrastText: '#FFFFFF',
});

export const purple = withAlphas({
  lightest: '#F5F3FF',
  light: '#C4B5FD',
  main: '#7C3AED',
  dark: '#5B21B6',
  darkest: '#4C1D95',
  contrastText: '#FFFFFF',
});

export const brown = withAlphas({
  lightest: '#FDF8F0',
  light: '#D4A574',
  main: '#92400E',
  dark: '#78350F',
  darkest: '#451A03',
  contrastText: '#FFFFFF',
});
